import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { localize } from "redux-i18n";
import { Row, Col } from "@components";

export const Header = props => (
  <Row className="border-bottom">
    <Col className="col-12">
      <Link aria-label={props.t("GO_HOME")} to="/">
        <img
          className="mx-auto d-block w-25"
          src="/assets/svg/logo.svg"
          alt={props.t("HOME_LOGO")}
        />
      </Link>
    </Col>
    <Col className="col-12">
      <p className="text-center mt-3 small text-secondary">{props.t("BRAND_HEADING")}</p>
    </Col>
  </Row>
);

Header.propTypes = {
  t: PropTypes.func.isRequired,
};

export default localize()(Header);
